<!--
 * @Description: 收付通商户列表页面
 * @Author: sunhuihong
 * @Date: 2022-09-29 16:43:52
 * @LastEditTime: 2023-10-18 13:50:38
-->
<template>
  <div class="body">
    <el-row class="bk-search" style="margin: 25px 40px;" :gutter="0" type="flex" justify="space-between" >
      <el-col :span="8" style="text-align: left;">
        <span class="search-title">机构名称：</span>
        <el-select size="small" filterable  v-model="filterParams.institutionId" clearable  placeholder="请输入/选择" 
          :filter-method="(value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this)"
					@visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)" 
          style="width: 240px;" >
          <el-option v-for="item in institutionList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" >
        <span class="search-title">微信商户号：</span>
        <el-input size="small"  style="width: 240px;"  v-model="filterParams.ecmMerchantId" clearable placeholder="请输入微信商户号">
        </el-input>
      </el-col>
      <el-col :span="8" style="text-align: right;">
        <el-button size="small" @click="handleQuery" type="primary" icon="el-icon-search" style="width: 80px;">
          搜 索
        </el-button>
        <el-button v-if="merchantPrivilege && merchantPrivilege.canAdd && dataPvgList.includes('LKL_1_MBR_APPLY')" @click="handleApplyMerchant" 
          size="small" class="apply-style" icon="el-icon-document-add" plain style="width: 80px;">
          申 请
        </el-button>
        <el-tooltip  v-else  effect="light" content="一家机构只能申请一次" placement="top-start">
          <div style="display: inline-block;">
            <el-button size="small" type="info" icon="el-icon-document-add" disabled  plain  
              style="color: #868686; background: #ECECEC;">申 请
            </el-button>        
          </div>
        </el-tooltip>        
      </el-col>      
    </el-row>
    <div class="main-line"></div>
    <!-- 收付通商户列表有数据 -->
    <div class="merchant-list-content" v-if="dataTable && dataTable.length">
      <el-table  style="margin: 20px 40px; border: 1px solid #f0f0f0;" :style="tableWidth" ref="table" :data="dataTable" 
        :header-cell-style="{ 'text-align': 'left','background-color': '#EFF5FA'}">
        <el-table-column prop="institutionName" label="申请机构" min-width="18%" align="left"></el-table-column>
        <el-table-column prop="ecmMerchantId" label="微信商户号" min-width="12%" align="left"></el-table-column>
        <el-table-column  label="经营主体" min-width="12%" align="left">
          <template slot-scope="scope">
            {{scope.row.type == 1 ? '企业' : scope.row.type == 2 ? '小微商户' : ''}}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商户简称" min-width="17%" align="left"></el-table-column>
        <el-table-column prop="reviewPassTime" label="开通成功时间" min-width="17%" sortable align="left"></el-table-column>
        <el-table-column  label="状态" min-width="10%" align="left">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" active-color="#13ce66" :active-value="1" :inactive-value="0" 
              @change="handleStatusSwitch(scope.$index,scope.row.status,scope.row.id)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column  label="操作" min-width="14%" align="left">
          <template slot-scope="scope">
            <el-button @click="handleDetailClick(scope.row)" type="text" size="small">详情</el-button>
            <template v-if="merchantPrivilege && merchantPrivilege.canSelectSharedCfg">
              <el-divider direction="vertical"></el-divider>
              <el-button @click="handleRsharingSetting(scope.row)" type="text" size="small">分账设置</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-row class="foot-pagination">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage" 
        :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize" 
        layout="total,prev, pager, next,sizes,jumper" :total="totalNumber" />
      </el-row>
    </div>
    <!-- 收付通商户列表无数据 -->
    <div v-else>
      <!-- 有筛选条件没有列表数据显示 -->
      <div v-show="placeholderMsg == 'noDataPlaceholder'">
        <el-empty style="margin-top: 100px;" description="暂无数据"></el-empty>
      </div>
      <!-- 无筛选条件没有列表数据显示 -->
      <div v-show="placeholderMsg == 'applyMchPlaceholder'">
        <!-- 机管已申提交请收付通商户显示占位 -->
        <div class="apply-sucess" v-if="merchantPrivilege && merchantPrivilege.canAdd == false">
          <img style="width: 100px; height: 125px;" src="@/assets/common/icon-common-review-sucess.png" alt="">
          <div class="apply-sucess-title">恭喜你！申请商户已提交成功</div>
          <div class="apply-sucess-des">
            <span>您的申请已提交成功，请耐心等待1-2个工作日,可在</span>
            <span style="cursor: pointer; color: #3A7FF3;" @click="handleMchReview">审核管理-商户审核</span>
            <span>模块查看审核进度哦！</span>
          </div>
        </div>
        <!-- 未申请收付通商户显示申请占位图 -->
        <div class="merchant-apply" v-else>
          <img style="width: 293px; height: 184px;" src="@/assets/common/img-common-placeholder.png" alt="">
          <div class="merchant-apply-des">
            <span>平台已开通电商收付通，您可以</span>
            <span style="color: #3A7FF3; font-size: 18px;" 
              :style="{'cursor' : merchantPrivilege && merchantPrivilege.canAdd ? 'pointer' : ''}" 
              @click="handleApplyMerchant">点击申请收付通商户
            </span>
            <span>,申请成功后订单收款到机构账户，可进行自动分账</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 申请收费通商户抽屉 -->
    <mch-apply-form  :visible="showMahApplyForm" :instId="instId" :mode="mahApplyForm" 
      @close-drawer="closeMchApplyForm"/>
    
    <!-- 收付通商户详情抽屉 -->
    <mch-details  :visible="showMchDetails" :mchId="mchId" @close-drawer="closeMchDetails"/>

    <!-- 分账设置弹框 -->
    <sharing-setup :visible="showSharingSetupDialog" :mchId="mchId" :instId="instId" 
      :canSharingCfg="merchantPrivilege.canSharingCfg" @close-dialog="closeSharingSetupDialog"/>

    <!-- 申请收付通商户提交成功抽屉 -->
    <mch-submit-sucess :visible="showMchSubmitSucessDrawer" :currentSuccessMchInstId="currentSuccessMchInstId"
      @close-drawer="closeMchSubmitSucessDrawer"/>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import MchApplyForm from './components/MchApplyForm.vue'
import MchDetails from './components/MchDetails.vue'
import SharingSetup from './components/SharingSetup.vue'
import MchSubmitSucess from './components/MchSubmitSucess.vue'

export default {
  name: 'MerchantList',
  components: {
    'mch-apply-form': MchApplyForm,
    'mch-details': MchDetails,
    'sharing-setup': SharingSetup,
    'mch-submit-sucess': MchSubmitSucess
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      filterParams: {
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      totalNumber: 0,
      
      placeholderMsg: '',//根据过滤条件查询商户列表数据，返回的msg 
      institutionList: [],
      srcInstitutionList: [],
      merchantPrivilege: {}, //当前用户商户操作的权限数据
      dataTable: null,
      showMchApplyForm: false,//是否显示申请收付通商户表单组件

      //以下是收付通商户表单抽屉组件操作
      showMahApplyForm: false,
      mahApplyForm: '',
      instId: '',//调用申请收付通商户表单组件，分账设置组件 必传(机构id)

      //以下是收付通商户详情抽屉组件操作
      showMchDetails: false,
      mchId: '',//指定商户的id

      //是否显示分账设置弹框
      showSharingSetupDialog: false,

      //是否显示商户审核成功抽屉
      showMchSubmitSucessDrawer: false,
      currentSuccessMchInstId: '',//申请成功的当前商户机构id
      
    }
  },

  computed: {
    tableWidth() {
      return 'width:' + (this.$root.contentWidth - 80) + 'px';
    },
  },
  
  methods:{
    async initData() {
      await this.getDataPvg4CurRole();
      this.merchantPrivilege = await this.queryMerchantPrivilege(); 
      await this.getFilterDo();
      await this.listMerchants();
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'LKL'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    //获取当前用户商户操作的权限
    queryMerchantPrivilege() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_MERCHANT_PRIVIAGE).then(result => {
          if (result != null) {
            console.log(this.filterParams.ecmMerchantId)
            resolve(result.data);
          }
        })
      })
    },

    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_MERCHANT_FILTER_DO).then(result => {
          if (result != null) {
            this.institutionList = result.data.institutionList;
            this.srcInstitutionList = result.data.institutionList;
            resolve();
          }
        })
      })
    },

    listMerchants() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_PAGE_MERCHANTS, this.filterParams).then(result => {
          if (result != null) {
            this.placeholderMsg = result.msg;
            this.dataTable = result.data || [];
            this.totalNumber = result.totalNumber;
            resolve();
          }
        })
      })
    },

    //收付通商户机构状态更改
    handleStatusSwitch(index, val, mchId) {
      let item = this.dataTable[index];
      item.status = val == 1 ? 0 : 1;
      let status = val == 1 ? "enable" : "disable";
      let strMessage = val == 1 ? '确认是否启用？' : '确认是否停用？';
      this.$confirm(strMessage, '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.queryStatusChange(mchId, status);
      })
    },

    queryStatusChange(mchId, status) {
      let url = this.commonUtil.fillUrlArgments(Constant.URL_UPDATE_MERCHANT_STATUS, mchId, status);
      this.appAxios("PUT", url).then(result => {
        if(result == null) {
          this.$message({type: 'error',	message: result.msg});
          return;
        }
        this.listMerchants();
      });
    },

    //申请收付通商户
    handleApplyMerchant() { 
      if (this.merchantPrivilege && !this.merchantPrivilege.canAdd) {
        return;
      }
      this.instId = 0;//新增传0
      this.showMchApplyForm = true;
      this.showMahApplyForm = true;
      this.mahApplyForm = 'add';
    },
    
    //搜索
    handleQuery() {
      this.listMerchants();
    },
        
    //详情
    handleDetailClick(val) {
      this.mchId = val.id;
      this.showMchDetails = true;
    },

    //分账设置
    handleRsharingSetting(val) {
      this.instId = val.institutionId;
      this.mchId = val.id;
      this.showSharingSetupDialog = true;
    },

    //关闭收付通商户表单抽屉
    closeMchApplyForm(data) {
      this.showMahApplyForm = false;
      if (typeof data == 'object' && data.refresh) {
        this.initData();
        this.showMchSubmitSucessDrawer = true;
        this.mchId = data.mchId;
        this.currentSuccessMchInstId = data.instId;
      }
    },

    //关闭收付通商户详情抽屉
    closeMchDetails() {
      this.showMchDetails = false; 
    },
    
    //关闭分账设置弹框
    closeSharingSetupDialog(refresh) {
      this.showSharingSetupDialog = false;
      if (refresh) {
        this.listMerchants();
      }
    },

    //关闭申请商户已提交成功抽屉
    closeMchSubmitSucessDrawer(refresh) {
      this.showMchSubmitSucessDrawer = false;
      if (refresh) {
        this.showMchDetails = true; 
      }
    },

    handleMchReview() {
      this.$router.push({name: 'mchreview'});
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listMerchants();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listMerchants();
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: '机构管理', text2: '收付通商户'});
    this.initData();
  }
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
  display: inline-block;
  text-align: right;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
}

.foot-pagination {
  text-align: right;
  right: 40px;
  border: solid 0px;
}

.apply-sucess {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 120px;
}

.apply-sucess-des {
  width:380px;
  text-align:left;
  font-size: 14px;
  line-height: 20px;
  color: #666666;
}

.apply-sucess-title {
  font-size: 15px;
  font-weight: 400;
  color: #333333;
  line-height: 21px;
  margin: 15px 0;
}

.merchant-apply {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 120px;
}

.merchant-apply-des {
  width: 380px;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  margin-top: 30px;
}

.apply-style {
  background: #EDF5FF;
  border: 1px solid #B4D8FF;
  color: #3E7EF5;
}
</style>


// WEBPACK FOOTER //
// src/components/mchmng/MerchantList.vue